import { DetailSectionNav } from '../shared/DetailSectionNav';
import { opportunitySections } from './opportunitySections';

export function OpportunitySectionNav({ active, onChange, photos, documents }: {
  active: string; onChange: (value: string) => void; photos: number; documents: number;
}) {
  return <DetailSectionNav entity="Opportunity" active={active} onChange={onChange}
    sections={opportunitySections.map(section => ({
      ...section, value: section.key,
      title: `${section.title}${section.key === 'photos' ? ` (${photos})` : section.key === 'documents' ? ` (${documents})` : ''}`,
    }))} />;
}
